import PropTypes from 'prop-types';
import React from 'react';

// One arm of the IF / THEN rail. The pills are grammar, not decoration — "IF these fire,
// THEN this happens" is the sentence the whole section is making — so they live inside the
// arm's heading rather than being hidden from assistive tech, and the cards below sit in a
// group labelled by it. The connector line between the arms is a CSS ::before with no DOM.
const RailGroup = ({ pill, caption, groupId, children }) => (
  <div className="automation-rules__rail-arm">
    <h4 className="automation-rules__rail-heading" id={groupId}>
      <span
        className={`automation-rules__rail-pill${
          pill === 'THEN' ? ' automation-rules__rail-pill--then' : ''
        }`}
      >
        {pill}
      </span>
      {/* JSX drops a whitespace-only line between two expressions, so without this the
          accessible name runs together as "IFan order trips...". CSS grid separates them
          visually, so it only ever showed up in screen readers — and this heading also
          names the role="group" below it. */}
      {' '}
      {caption}
    </h4>
    <div className="automation-rules__stack" role="group" aria-labelledby={groupId}>
      {children}
    </div>
  </div>
);

RailGroup.propTypes = {
  pill: PropTypes.oneOf(['IF', 'THEN']).isRequired,
  caption: PropTypes.string.isRequired,
  groupId: PropTypes.string.isRequired,
  children: PropTypes.node,
};

RailGroup.defaultProps = { children: null };

export default RailGroup;
